import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const biolinkQRCode = createAsyncThunk('biolinkQRCode', async (data) => {
    try {
        const res = await axios({

            method: 'post',
            url: process.env.REACT_APP_API_URL + `user_qrcode_generate`,
            data: {
                "user_url": data?.biolink_url
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const biolinkQRCodeSlice = createSlice({
    name: 'biolinkQRCode',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(biolinkQRCode.fulfilled, (state, action) => {
            if (action?.payload?.status === 201 || action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                state.data = [];
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.data = [];
            }
        });
        builder.addCase(biolinkQRCode.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default biolinkQRCodeSlice.reducer; 